import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import BellIcon from '../../v2/icons/BellIcon';
import DocumentIcon from '../../v2/icons/DocumentIcon';
import UserCircleIcon from '../../v2/icons/UserCircleIcon';
import LibraryIcon from '../../v2/icons/LibraryIcon';
import VerticalNav from '../../v2/navs/VerticalNav';
import CodeIcon from '../../v2/icons/CodeIcon';
const Sidebar = ({ activePage, t }) => {
    const carrierCenterActive = activePage === 'profile';
    const invoicesActive = activePage === 'invoicesActive';
    const billingActive = activePage === 'billing';
    const notificationsActive = activePage === 'notifications';
    const developerActive = activePage === 'developer';
    return (React.createElement(VerticalNav, null,
        React.createElement(VerticalNav.NavItemWithIcon, { url: "/profile", active: carrierCenterActive, title: titleize(t('PROFILE', { count: 1 })) }, (iconClassName) => (React.createElement(UserCircleIcon, { size: "medium", className: iconClassName }))),
        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
            React.createElement(VerticalNav.NavItemWithIcon, { url: "/billing", active: billingActive, title: t('BILLING') }, (iconClassName) => (React.createElement(LibraryIcon, { size: "medium", className: iconClassName })))),
        React.createElement(VerticalNav.NavItemWithIcon, { url: "/notifications", active: notificationsActive, title: titleize(t('NOTIFICATION', { count: 2 })) }, (iconClassName) => (React.createElement(BellIcon, { size: "medium", className: iconClassName }))),
        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
            React.createElement(VerticalNav.NavItemWithIcon, { url: "/invoices", active: invoicesActive, title: t('INVOICE', { count: 2 }) }, (iconClassName) => (React.createElement(DocumentIcon, { size: "medium", className: iconClassName })))),
        React.createElement(VerticalNav.NavItemWithIcon, { url: "/developer", active: developerActive, title: titleize(t('DEVELOPER', { count: 1 })) }, (iconClassName) => (React.createElement(CodeIcon, { size: "medium", className: iconClassName })))));
};
Sidebar.propTypes = {
    activePage: PropTypes.string,
};
Sidebar.defaultProps = {
    activePage: 'profile',
};
export default withTranslation()(Sidebar);
